<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="title">
        Création d'un Utilisateur
        <span
          class="is-padding-left-xsmall"
          v-helper.bottom="'4508tGHJLoaA5KwRseJpAh'">
          <i class="fal fa-question-circle"></i>
        </span>
      </template>
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <user-form
          @submit="createUser"
          :loading="loading"></user-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'UserCreate',
  components: {
    UserForm: () => import('@/components/users/UserForm')
  },
  mixins: [User]
}
</script>
